module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAsCAMAAAAkRNp0AAAAAXNSR0IB2cksfwAAADxQTFRFAAAA////////////////////////////////////////////////////////////////////////////2EloEwAAABR0Uk5TAMD/v0AgnxB/8OBw76Bf3zBQgLB8EKWWAAAA6UlEQVR4nO2VwRKDIAxEIYpI1aL2//+1KGmkmghcO90ZPTA7sAnwUOoiDUHNdZwR7Cq0xi+vNlrbrNF0gOrMrdH2AO6xGbdfb2XnMAJMOJmZAManFNID6CRiG7rmuchzE1ZdvseWEKOZmWrcwERySX373vgQcmWLsGuI7OP+YWsmsTXmhRZV0HDclKJtJGv+cKBnL0vfW8lTcorQ87f+pLWEUDq9Bbk5k1uQX772wmQIRRSLkWVCHRT73BSJUCnFjkAMoc4UI50JxVHsWC4hlEQxKoIIJVOMRIS6oRip+NlQNY9RzRMnUewNZg8GYVllJZEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/polygon-active@2x.png
// module id = 885
// module chunks = 0